var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUseitMidsummerDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 319,
  height: 321,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#useit-midsummer-dark_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#9DD3FC",
  fillRule: "evenodd",
  d: "M0 320.738h318.96V0H0z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#7AC48E",
  strokeWidth: 7,
  d: "M20.64 110.265h276.12m-274.102-.84L160.7 2.77m-.698 1.9 134.811 105.34"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7AC48E",
  fillRule: "evenodd",
  d: "M151.332 320.505h16.28V0h-16.28z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F6B3F",
  fillRule: "evenodd",
  d: "m149.432 171.834 2.052 5.638 18.262-6.647-2.052-5.638zm0 21.009 2.052 5.638 18.262-6.647-2.052-5.638zm-.409 21.26 2.052 5.638 18.262-6.647-2.052-5.638zm.99 21.01 2.052 5.638 18.262-6.647-2.052-5.638zm0 21.51 2.052 5.638 18.262-6.647-2.052-5.638zm0 21.229 2.052 5.638 18.262-6.647-2.052-5.638zm-.709-127.278 2.052 5.638 18.262-6.647-2.052-5.638zm-.281-21.883 2.052 5.638 18.262-6.647-2.052-5.638zm.409-21.099 2.052 5.638 18.262-6.647-2.052-5.638zm-.409-21.26 2.052 5.638 18.262-6.647-2.052-5.638zm0-22.044 2.052 5.638 18.262-6.647-2.052-5.638zm0-21.561 2.052 5.638 18.262-6.648-2.052-5.637zm-.48-21.26 2.052 5.638 18.262-6.647-2.052-5.638z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#2F6B3F",
  d: "m38.927 92.678 18.501-6.142m6.406-13.141 18.501-6.143m3.853-11.562 18.501-6.143m4.668-11.43 18.501-6.143m107.244 36.263 18.773 5.253m5.312 13.053 18.773 5.253m-65.576-41.434 18.773 5.253M190.479 33.18l18.773 5.252"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#7AC48E",
  strokeWidth: 9,
  d: "M69.32 176.039c18.81 0 34.059-14.656 34.059-32.735s-15.249-32.736-34.06-32.736c-18.81 0-34.06 14.656-34.06 32.736s15.25 32.735 34.06 32.735Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F6B3F",
  fillRule: "evenodd",
  d: "m62.139 118.98 5.985-.419-1.073-15.352-5.986.419zm10.111 0 5.984-.419-1.072-15.352-5.987.419z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M35.394 139.252c.62 0 1.12-1.251 1.12-2.794 0-1.542-.5-2.793-1.12-2.793-.619 0-1.12 1.251-1.12 2.793s.501 2.794 1.12 2.794",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M35.93 140.016c.556.271 1.612-.75 2.358-2.28s.901-2.99.345-3.262-1.612.75-2.358 2.28c-.747 1.53-.9 2.991-.345 3.262m-1.495-.338c.546-.29.402-1.63-.323-2.992-.724-1.363-1.754-2.232-2.3-1.941-.546.29-.402 1.63.323 2.992.724 1.363 1.754 2.231 2.3 1.941",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M34.762 140.004c.086-.613-1.083-1.283-2.61-1.498-1.528-.215-2.837.108-2.923.72-.086.613 1.083 1.284 2.611 1.498 1.528.215 2.836-.107 2.922-.72m6.766-1.329c-.15-.6-1.484-.784-2.982-.411-1.497.373-2.589 1.162-2.439 1.763.15.6 1.484.784 2.981.411s2.59-1.163 2.44-1.763",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M35.142 140.446c-.346-.513-1.663-.229-2.942.634-1.28.862-2.036 1.977-1.69 2.49s1.663.229 2.942-.633c1.279-.863 2.036-1.978 1.69-2.491",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M35.145 140.451c-.562.039-.94 1.208-.841 2.611.099 1.402.634 2.507 1.196 2.468s.939-1.208.84-2.611c-.097-1.402-.633-2.507-1.195-2.468",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M35.673 140.343c-.315.467.374 1.484 1.54 2.27s2.366 1.044 2.681.577-.374-1.483-1.54-2.27-2.366-1.044-2.681-.577",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7B140",
  fillRule: "evenodd",
  d: "M35.254 140.291c.42 0 .76-.291.76-.651s-.34-.651-.76-.651-.76.291-.76.651.34.651.76.651",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F7B140",
  d: "M35.254 140.291c.42 0 .76-.291.76-.651s-.34-.651-.76-.651-.76.291-.76.651.34.651.76.651Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M43.71 121.478c.619 0 1.12-1.251 1.12-2.794 0-1.542-.501-2.793-1.12-2.793s-1.12 1.251-1.12 2.793.5 2.794 1.12 2.794",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M44.246 122.242c.556.271 1.612-.75 2.358-2.28s.901-2.991.345-3.262-1.612.75-2.358 2.28c-.747 1.53-.901 2.991-.345 3.262m-1.495-.338c.546-.29.402-1.63-.323-2.992-.724-1.363-1.754-2.231-2.3-1.941s-.402 1.63.323 2.992c.724 1.363 1.754 2.231 2.3 1.941",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M43.078 122.23c.086-.612-1.083-1.283-2.61-1.498-1.528-.215-2.837.108-2.923.72-.086.613 1.083 1.284 2.611 1.498 1.528.215 2.836-.107 2.922-.72m6.766-1.329c-.15-.6-1.484-.784-2.982-.411-1.497.373-2.589 1.162-2.439 1.763.15.6 1.484.784 2.981.411s2.59-1.163 2.44-1.763",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M43.457 122.672c-.346-.513-1.663-.229-2.942.634-1.279.862-2.036 1.977-1.69 2.49s1.663.229 2.942-.633c1.28-.863 2.036-1.978 1.69-2.491",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M43.46 122.677c-.562.039-.938 1.208-.84 2.611.099 1.402.634 2.507 1.196 2.468s.938-1.208.84-2.611c-.097-1.402-.633-2.507-1.195-2.468Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M43.989 122.569c-.315.467.374 1.484 1.54 2.27s2.366 1.044 2.68.577c.316-.467-.373-1.483-1.54-2.27-1.164-.786-2.365-1.044-2.68-.577",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7B140",
  fillRule: "evenodd",
  d: "M43.57 122.517c.42 0 .76-.292.76-.651s-.34-.651-.76-.651-.76.291-.76.651c0 .359.34.651.76.651",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F7B140",
  d: "M43.57 122.517c.42 0 .76-.292.76-.651s-.34-.651-.76-.651-.76.291-.76.651c0 .359.34.651.76.651Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M40.254 160.325c.619 0 1.12-1.251 1.12-2.794 0-1.542-.501-2.793-1.12-2.793s-1.12 1.251-1.12 2.793.5 2.794 1.12 2.794",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M40.79 161.089c.556.271 1.612-.75 2.358-2.28s.901-2.99.345-3.262-1.612.75-2.358 2.28c-.747 1.53-.901 2.991-.345 3.262m-1.495-.338c.546-.29.402-1.63-.323-2.992-.724-1.363-1.754-2.232-2.3-1.941-.546.29-.402 1.63.323 2.992.724 1.363 1.754 2.231 2.3 1.941",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M39.622 161.077c.086-.613-1.083-1.283-2.61-1.498-1.528-.215-2.837.108-2.923.72-.086.613 1.083 1.284 2.61 1.498 1.529.215 2.837-.107 2.923-.72m6.766-1.329c-.15-.6-1.484-.784-2.982-.411-1.497.373-2.589 1.162-2.439 1.763.15.6 1.484.784 2.981.411s2.59-1.163 2.44-1.763",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M40.001 161.519c-.346-.513-1.663-.229-2.942.634-1.279.862-2.036 1.977-1.69 2.49s1.663.229 2.942-.633c1.28-.863 2.036-1.978 1.69-2.491",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M40.004 161.524c-.562.039-.939 1.208-.84 2.611.098 1.402.633 2.507 1.195 2.468s.94-1.208.841-2.611c-.098-1.402-.634-2.507-1.196-2.468",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M40.533 161.416c-.315.467.374 1.484 1.54 2.27s2.366 1.044 2.68.577c.316-.467-.373-1.483-1.54-2.27-1.164-.786-2.365-1.044-2.68-.577",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7B140",
  fillRule: "evenodd",
  d: "M40.114 161.364c.42 0 .76-.291.76-.651s-.34-.651-.76-.651-.76.291-.76.651.34.651.76.651",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F7B140",
  d: "M40.114 161.364c.42 0 .76-.291.76-.651s-.34-.651-.76-.651-.76.291-.76.651.34.651.76.651Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M60.054 174.26c.619 0 1.12-1.251 1.12-2.794 0-1.542-.501-2.793-1.12-2.793s-1.12 1.251-1.12 2.793.5 2.794 1.12 2.794",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M60.59 175.024c.556.271 1.612-.75 2.358-2.28s.901-2.99.345-3.262-1.612.75-2.358 2.28c-.747 1.53-.901 2.991-.345 3.262m-1.495-.338c.546-.29.402-1.63-.323-2.992-.724-1.363-1.754-2.231-2.3-1.941s-.402 1.63.323 2.992c.724 1.362 1.754 2.231 2.3 1.941",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M59.422 175.013c.086-.613-1.083-1.283-2.61-1.498-1.528-.215-2.837.108-2.923.72-.086.613 1.083 1.284 2.611 1.498 1.528.215 2.836-.107 2.922-.72m6.766-1.33c-.15-.6-1.484-.784-2.982-.411-1.497.373-2.589 1.162-2.439 1.763.15.6 1.484.784 2.981.411s2.59-1.163 2.44-1.763",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M59.801 175.454c-.346-.513-1.663-.229-2.942.634-1.279.862-2.036 1.977-1.69 2.49s1.663.229 2.942-.633c1.28-.863 2.036-1.978 1.69-2.491",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M59.804 175.459c-.562.039-.939 1.208-.84 2.611.099 1.402.633 2.507 1.196 2.468s.939-1.208.84-2.611c-.097-1.402-.633-2.507-1.196-2.468",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M60.333 175.351c-.315.467.374 1.484 1.54 2.27s2.366 1.044 2.68.577c.316-.467-.373-1.483-1.54-2.27-1.164-.786-2.365-1.044-2.68-.577",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7B140",
  fillRule: "evenodd",
  d: "M59.914 175.299c.42 0 .76-.292.76-.651s-.34-.651-.76-.651-.76.291-.76.651c0 .359.34.651.76.651",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F7B140",
  d: "M59.914 175.299c.42 0 .76-.292.76-.651s-.34-.651-.76-.651-.76.291-.76.651c0 .359.34.651.76.651Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M87.653 170.774c.62 0 1.12-1.251 1.12-2.794 0-1.542-.5-2.793-1.12-2.793-.619 0-1.12 1.251-1.12 2.793s.501 2.794 1.12 2.794",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M88.19 171.537c.556.271 1.612-.75 2.358-2.28s.9-2.99.345-3.262c-.556-.271-1.612.75-2.358 2.28-.747 1.53-.901 2.991-.345 3.262m-1.495-.337c.546-.29.402-1.63-.323-2.992-.724-1.363-1.754-2.231-2.3-1.941s-.402 1.63.323 2.992c.724 1.362 1.754 2.231 2.3 1.941",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M87.022 171.526c.086-.613-1.083-1.283-2.61-1.498-1.528-.215-2.837.108-2.923.72-.086.613 1.083 1.284 2.61 1.498 1.529.215 2.837-.107 2.923-.72m6.766-1.33c-.15-.6-1.484-.784-2.982-.411-1.497.373-2.589 1.162-2.439 1.763.15.6 1.484.784 2.981.411s2.59-1.163 2.44-1.763",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M87.401 171.967c-.346-.513-1.663-.229-2.942.634-1.279.862-2.036 1.977-1.69 2.49s1.663.229 2.942-.633c1.28-.863 2.036-1.978 1.69-2.491",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M87.404 171.972c-.562.039-.939 1.208-.84 2.611.098 1.402.633 2.507 1.195 2.468s.94-1.208.841-2.611c-.098-1.402-.634-2.507-1.196-2.468",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M87.932 171.864c-.315.467.374 1.484 1.54 2.27s2.366 1.044 2.681.577-.374-1.483-1.54-2.27-2.366-1.044-2.68-.577Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7B140",
  fillRule: "evenodd",
  d: "M87.514 171.813c.42 0 .76-.292.76-.651s-.34-.651-.76-.651-.76.291-.76.651c0 .359.34.651.76.651",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F7B140",
  d: "M87.514 171.813c.42 0 .76-.292.76-.651s-.34-.651-.76-.651-.76.291-.76.651c0 .359.34.651.76.651Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M102.44 149.738c.619 0 1.12-1.251 1.12-2.794 0-1.542-.501-2.793-1.12-2.793s-1.12 1.251-1.12 2.793.501 2.794 1.12 2.794",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M102.976 150.501c.556.271 1.612-.75 2.358-2.28s.901-2.99.345-3.262-1.612.75-2.358 2.28c-.747 1.53-.901 2.991-.345 3.262m-1.495-.337c.546-.29.402-1.63-.323-2.992-.724-1.363-1.754-2.232-2.3-1.941-.546.29-.402 1.63.323 2.992.724 1.363 1.754 2.231 2.3 1.941",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M101.808 150.49c.086-.613-1.083-1.283-2.61-1.498-1.528-.215-2.837.108-2.923.72-.086.613 1.083 1.284 2.611 1.498 1.528.215 2.836-.107 2.922-.72m6.766-1.33c-.15-.6-1.484-.784-2.982-.411-1.497.373-2.589 1.162-2.439 1.763.15.6 1.484.784 2.981.411s2.59-1.163 2.44-1.763",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M102.187 150.931c-.346-.513-1.663-.229-2.941.634-1.28.862-2.036 1.977-1.69 2.49s1.663.229 2.941-.633c1.279-.863 2.036-1.978 1.69-2.491",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M102.19 150.936c-.562.039-.939 1.208-.841 2.611.099 1.402.634 2.507 1.196 2.468s.939-1.208.841-2.611c-.098-1.402-.634-2.507-1.196-2.468",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M102.719 150.828c-.315.467.374 1.484 1.54 2.27s2.366 1.044 2.681.577-.374-1.483-1.54-2.27-2.366-1.044-2.681-.577",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7B140",
  fillRule: "evenodd",
  d: "M102.3 150.776c.42 0 .76-.291.76-.651s-.34-.651-.76-.651-.76.291-.76.651.34.651.76.651",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F7B140",
  d: "M102.3 150.776c.42 0 .76-.291.76-.651s-.34-.651-.76-.651-.76.291-.76.651.34.651.76.651Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M97.48 125.069c.618 0 1.12-1.251 1.12-2.794 0-1.542-.502-2.793-1.12-2.793-.62 0-1.12 1.251-1.12 2.793s.5 2.794 1.12 2.794",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M98.016 125.832c.556.271 1.612-.75 2.358-2.28s.901-2.99.345-3.262-1.612.75-2.358 2.28c-.747 1.53-.901 2.991-.345 3.262m-1.496-.337c.547-.29.403-1.63-.322-2.992-.724-1.363-1.754-2.232-2.3-1.941-.546.29-.402 1.63.323 2.992.724 1.363 1.754 2.231 2.3 1.941Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M96.847 125.821c.086-.613-1.083-1.283-2.61-1.498-1.528-.215-2.837.108-2.923.72-.086.613 1.083 1.284 2.611 1.498 1.528.215 2.836-.107 2.922-.72m6.767-1.33c-.15-.6-1.484-.784-2.982-.411-1.497.373-2.59 1.162-2.44 1.763.15.6 1.485.784 2.982.411s2.59-1.163 2.44-1.763",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M97.227 126.262c-.346-.513-1.663-.229-2.942.634-1.28.862-2.036 1.977-1.69 2.49s1.663.229 2.942-.633c1.279-.863 2.036-1.978 1.69-2.491",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M97.23 126.267c-.562.039-.939 1.208-.841 2.611.099 1.402.634 2.507 1.196 2.468s.939-1.208.841-2.611c-.098-1.402-.634-2.507-1.196-2.468",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M97.758 126.159c-.315.467.374 1.484 1.54 2.27s2.366 1.044 2.681.577-.374-1.483-1.54-2.27-2.366-1.044-2.68-.577Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7B140",
  fillRule: "evenodd",
  d: "M97.34 126.108c.42 0 .76-.291.76-.651s-.34-.651-.76-.651-.76.291-.76.651.34.651.76.651",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F7B140",
  d: "M97.34 126.108c.42 0 .76-.291.76-.651s-.34-.651-.76-.651-.76.291-.76.651.34.651.76.651Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#7AC48E",
  strokeWidth: 9,
  d: "M245.833 176.736c18.811 0 34.06-14.656 34.06-32.735s-15.249-32.736-34.06-32.736-34.06 14.656-34.06 32.736 15.249 32.735 34.06 32.735Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F6B3F",
  fillRule: "evenodd",
  d: "m238.049 118.98 5.985-.419-1.073-15.352-5.986.419zm10.536 0 5.985-.419-1.073-15.352-5.986.419z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M271.638 121.908c.619 0 1.12-1.251 1.12-2.794 0-1.542-.501-2.793-1.12-2.793s-1.12 1.251-1.12 2.793.501 2.794 1.12 2.794",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M272.174 122.671c.556.271 1.612-.75 2.358-2.28s.901-2.991.345-3.262-1.612.75-2.358 2.28c-.747 1.53-.901 2.991-.345 3.262m-1.495-.337c.546-.29.402-1.63-.323-2.992-.724-1.363-1.754-2.231-2.3-1.941s-.402 1.63.323 2.992c.724 1.363 1.754 2.231 2.3 1.941",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M271.006 122.66c.086-.612-1.083-1.283-2.61-1.498-1.528-.215-2.837.108-2.923.72-.086.613 1.083 1.284 2.611 1.498 1.528.215 2.836-.107 2.922-.72m6.766-1.33c-.15-.6-1.484-.784-2.982-.411-1.497.373-2.589 1.162-2.439 1.763.15.6 1.484.784 2.981.411s2.59-1.163 2.44-1.763",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M271.385 123.102c-.346-.513-1.663-.229-2.942.634-1.279.862-2.036 1.977-1.69 2.49s1.663.229 2.942-.633c1.279-.863 2.036-1.978 1.69-2.491",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M271.388 123.106c-.562.039-.939 1.208-.841 2.611.099 1.402.634 2.507 1.196 2.468s.939-1.208.841-2.611c-.098-1.402-.634-2.507-1.196-2.468",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M271.917 122.998c-.315.467.374 1.484 1.54 2.27s2.366 1.044 2.681.577-.374-1.483-1.54-2.27-2.366-1.044-2.681-.577",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7B140",
  fillRule: "evenodd",
  d: "M271.498 122.947c.42 0 .76-.292.76-.651s-.34-.651-.76-.651-.76.291-.76.651c0 .359.34.651.76.651",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F7B140",
  d: "M271.498 122.947c.42 0 .76-.292.76-.651s-.34-.651-.76-.651-.76.291-.76.651c0 .359.34.651.76.651Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M280.102 143.581c.619 0 1.12-1.251 1.12-2.794 0-1.542-.501-2.793-1.12-2.793s-1.12 1.251-1.12 2.793.501 2.794 1.12 2.794",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M280.638 144.345c.556.271 1.612-.75 2.358-2.28s.901-2.991.345-3.262-1.612.75-2.358 2.28c-.747 1.53-.901 2.991-.345 3.262m-1.495-.338c.546-.29.402-1.63-.323-2.992-.724-1.363-1.754-2.231-2.3-1.941s-.402 1.63.323 2.992c.724 1.363 1.754 2.231 2.3 1.941",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M279.47 144.333c.086-.612-1.083-1.283-2.61-1.498-1.528-.215-2.837.108-2.923.72-.086.613 1.083 1.284 2.611 1.498 1.528.215 2.836-.107 2.922-.72m6.766-1.329c-.15-.6-1.484-.784-2.982-.411-1.497.373-2.589 1.162-2.439 1.763.15.6 1.484.784 2.981.411s2.59-1.163 2.44-1.763",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M279.849 144.775c-.346-.513-1.663-.229-2.942.634-1.279.862-2.036 1.977-1.69 2.49s1.663.229 2.942-.633c1.279-.863 2.036-1.978 1.69-2.491",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M279.852 144.78c-.562.039-.939 1.208-.841 2.611.099 1.402.634 2.507 1.196 2.468s.939-1.208.841-2.611c-.098-1.402-.634-2.507-1.196-2.468",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M280.38 144.672c-.315.467.374 1.484 1.54 2.27s2.366 1.044 2.681.577-.374-1.483-1.54-2.27-2.366-1.044-2.681-.577",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7B140",
  fillRule: "evenodd",
  d: "M279.962 144.62c.42 0 .76-.292.76-.651s-.34-.651-.76-.651-.76.291-.76.651c0 .359.34.651.76.651",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F7B140",
  d: "M279.962 144.62c.42 0 .76-.292.76-.651s-.34-.651-.76-.651-.76.291-.76.651c0 .359.34.651.76.651Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M272.901 164.841c.619 0 1.12-1.251 1.12-2.794 0-1.542-.501-2.793-1.12-2.793s-1.12 1.251-1.12 2.793.501 2.794 1.12 2.794",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M273.438 165.604c.556.271 1.612-.75 2.358-2.28s.901-2.99.345-3.262-1.612.75-2.358 2.28c-.747 1.53-.901 2.991-.345 3.262m-1.495-.337c.546-.29.402-1.63-.323-2.992-.724-1.363-1.754-2.232-2.3-1.941-.546.29-.402 1.63.323 2.992.724 1.363 1.754 2.231 2.3 1.941",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M272.27 165.593c.086-.613-1.083-1.283-2.61-1.498-1.528-.215-2.837.108-2.923.72-.086.613 1.083 1.284 2.611 1.498 1.528.215 2.836-.107 2.922-.72m6.766-1.329c-.15-.6-1.484-.784-2.982-.411-1.497.373-2.589 1.162-2.439 1.763.15.6 1.484.784 2.981.411s2.59-1.163 2.44-1.763",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M272.649 166.034c-.346-.513-1.663-.229-2.942.634-1.279.862-2.036 1.977-1.69 2.49s1.663.229 2.942-.633c1.279-.863 2.036-1.978 1.69-2.491",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M272.652 166.04c-.562.039-.939 1.208-.841 2.611.099 1.402.634 2.507 1.196 2.468s.939-1.208.841-2.611c-.098-1.402-.634-2.507-1.196-2.468",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M273.18 165.931c-.315.467.374 1.484 1.54 2.27s2.366 1.044 2.681.577-.374-1.483-1.54-2.27-2.366-1.044-2.681-.577",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7B140",
  fillRule: "evenodd",
  d: "M272.761 165.88c.42 0 .76-.291.76-.651s-.34-.651-.76-.651-.76.291-.76.651.34.651.76.651",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F7B140",
  d: "M272.761 165.88c.42 0 .76-.291.76-.651s-.34-.651-.76-.651-.76.291-.76.651.34.651.76.651Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M247.553 175.666c.619 0 1.12-1.251 1.12-2.794 0-1.542-.501-2.793-1.12-2.793s-1.12 1.251-1.12 2.793.501 2.794 1.12 2.794",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M248.09 176.429c.556.271 1.612-.75 2.358-2.28s.901-2.99.345-3.262-1.612.75-2.358 2.28c-.747 1.53-.901 2.991-.345 3.262m-1.495-.337c.546-.29.402-1.63-.323-2.992-.724-1.363-1.754-2.231-2.3-1.941s-.402 1.63.323 2.992c.724 1.362 1.754 2.231 2.3 1.941",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M246.921 176.418c.086-.613-1.083-1.283-2.61-1.498-1.528-.215-2.837.108-2.923.72-.086.613 1.083 1.284 2.611 1.498 1.528.215 2.836-.107 2.922-.72m6.766-1.33c-.15-.6-1.484-.784-2.982-.411-1.497.373-2.589 1.162-2.439 1.763.15.6 1.484.784 2.981.411s2.59-1.163 2.44-1.763",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M247.301 176.86c-.346-.513-1.663-.229-2.942.634-1.279.862-2.036 1.977-1.69 2.49s1.663.229 2.942-.633c1.279-.863 2.036-1.978 1.69-2.491",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M247.304 176.864c-.562.039-.939 1.208-.841 2.611.099 1.402.634 2.507 1.196 2.468s.939-1.208.841-2.611c-.098-1.402-.634-2.507-1.196-2.468",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M247.832 176.756c-.315.467.374 1.484 1.54 2.27s2.366 1.044 2.681.577-.374-1.483-1.54-2.27-2.366-1.044-2.681-.577",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7B140",
  fillRule: "evenodd",
  d: "M247.413 176.705c.42 0 .76-.292.76-.651s-.34-.651-.76-.651-.76.291-.76.651c0 .359.34.651.76.651",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F7B140",
  d: "M247.413 176.705c.42 0 .76-.292.76-.651s-.34-.651-.76-.651-.76.291-.76.651c0 .359.34.651.76.651Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M220.517 164.733c.619 0 1.12-1.251 1.12-2.794 0-1.542-.501-2.793-1.12-2.793s-1.12 1.251-1.12 2.793.501 2.794 1.12 2.794",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M221.053 165.496c.556.271 1.612-.75 2.358-2.28s.901-2.99.345-3.262-1.612.75-2.358 2.28c-.747 1.53-.901 2.991-.345 3.262m-1.495-.337c.546-.29.402-1.63-.323-2.992-.724-1.363-1.754-2.231-2.3-1.941s-.402 1.63.323 2.992c.724 1.362 1.754 2.231 2.3 1.941",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M219.885 165.485c.086-.613-1.083-1.283-2.61-1.498-1.528-.215-2.837.108-2.923.72-.086.613 1.083 1.284 2.611 1.498 1.528.215 2.836-.107 2.922-.72m6.766-1.329c-.15-.6-1.484-.784-2.982-.411-1.497.373-2.589 1.162-2.439 1.763.15.6 1.484.784 2.981.411s2.59-1.163 2.44-1.763",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M220.264 165.927c-.346-.513-1.663-.229-2.942.634-1.279.862-2.036 1.977-1.69 2.49s1.663.229 2.942-.633c1.279-.863 2.036-1.978 1.69-2.491",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M220.268 165.931c-.562.039-.939 1.208-.841 2.611.099 1.402.634 2.507 1.196 2.468s.939-1.208.841-2.611c-.098-1.402-.634-2.507-1.196-2.468",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M220.796 165.823c-.315.467.374 1.484 1.54 2.27s2.366 1.044 2.681.577-.374-1.483-1.54-2.27-2.366-1.044-2.681-.577",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7B140",
  fillRule: "evenodd",
  d: "M220.377 165.772c.42 0 .76-.292.76-.651s-.34-.651-.76-.651-.76.291-.76.651c0 .359.34.651.76.651",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F7B140",
  d: "M220.377 165.772c.42 0 .76-.292.76-.651s-.34-.651-.76-.651-.76.291-.76.651c0 .359.34.651.76.651Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M212.452 142.237c.619 0 1.12-1.251 1.12-2.794 0-1.542-.501-2.793-1.12-2.793s-1.12 1.251-1.12 2.793.501 2.794 1.12 2.794",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M212.988 143.001c.556.271 1.612-.75 2.358-2.28s.901-2.99.345-3.262-1.612.75-2.358 2.28c-.747 1.53-.901 2.991-.345 3.262m-1.495-.338c.546-.29.402-1.63-.323-2.992-.724-1.363-1.754-2.232-2.3-1.941-.546.29-.402 1.63.323 2.992.724 1.363 1.754 2.231 2.3 1.941",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M211.82 142.989c.086-.613-1.083-1.283-2.61-1.498-1.528-.215-2.837.108-2.923.72-.086.613 1.083 1.284 2.611 1.498 1.528.215 2.836-.107 2.922-.72m6.766-1.329c-.15-.6-1.484-.784-2.982-.411-1.497.373-2.589 1.162-2.439 1.763.15.6 1.484.784 2.981.411s2.59-1.163 2.44-1.763",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M212.199 143.431c-.346-.513-1.663-.229-2.942.634-1.279.862-2.036 1.977-1.69 2.49s1.663.229 2.942-.633c1.279-.863 2.036-1.978 1.69-2.491",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M212.202 143.436c-.562.039-.939 1.208-.841 2.611.099 1.402.634 2.507 1.196 2.468s.939-1.208.841-2.611c-.098-1.402-.634-2.507-1.196-2.468",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M212.73 143.328c-.315.467.374 1.484 1.54 2.27s2.366 1.044 2.681.577-.374-1.483-1.54-2.27-2.366-1.044-2.681-.577",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7B140",
  fillRule: "evenodd",
  d: "M212.312 143.276c.42 0 .76-.291.76-.651s-.34-.651-.76-.651-.76.291-.76.651.34.651.76.651",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F7B140",
  d: "M212.312 143.276c.42 0 .76-.291.76-.651s-.34-.651-.76-.651-.76.291-.76.651.34.651.76.651Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M222.181 120.769c.619 0 1.12-1.251 1.12-2.794 0-1.542-.501-2.793-1.12-2.793s-1.12 1.251-1.12 2.793.501 2.794 1.12 2.794",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M222.717 121.533c.556.271 1.612-.75 2.358-2.28s.901-2.99.345-3.262-1.612.75-2.358 2.28c-.747 1.53-.901 2.991-.345 3.262m-1.495-.337c.546-.29.402-1.63-.323-2.992-.724-1.363-1.754-2.232-2.3-1.941-.546.29-.402 1.63.323 2.992.724 1.363 1.754 2.231 2.3 1.941",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M221.549 121.522c.086-.613-1.083-1.283-2.61-1.498-1.528-.215-2.837.108-2.923.72-.086.613 1.083 1.284 2.611 1.498 1.528.215 2.836-.107 2.922-.72m6.766-1.33c-.15-.6-1.484-.784-2.982-.411-1.497.373-2.589 1.162-2.439 1.763.15.6 1.484.784 2.981.411s2.59-1.163 2.44-1.763",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M221.929 121.963c-.346-.513-1.663-.229-2.942.634-1.279.862-2.036 1.977-1.69 2.49s1.663.229 2.942-.633c1.279-.863 2.036-1.978 1.69-2.491",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M221.932 121.968c-.562.039-.939 1.208-.841 2.611.099 1.402.634 2.507 1.196 2.468s.939-1.208.841-2.611c-.098-1.402-.634-2.507-1.196-2.468",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M222.46 121.86c-.315.467.374 1.484 1.54 2.27s2.366 1.044 2.681.577-.374-1.483-1.54-2.27-2.366-1.044-2.681-.577",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7B140",
  fillRule: "evenodd",
  d: "M222.041 121.808c.42 0 .76-.291.76-.651s-.34-.651-.76-.651-.76.291-.76.651.34.651.76.651",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F7B140",
  d: "M222.041 121.808c.42 0 .76-.291.76-.651s-.34-.651-.76-.651-.76.291-.76.651.34.651.76.651Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00F",
  fillRule: "evenodd",
  d: "m3.353 272.763 6.877 29.789 56.141-12.961-6.877-29.789z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#1A1919",
  strokeWidth: 2,
  d: "M14.238 320.748 2.556 271.609"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7F740",
  fillRule: "evenodd",
  d: "m6.68 285.237 1.35 5.846 55.72-12.864-1.35-5.846z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7F740",
  fillRule: "evenodd",
  d: "M28.622 266.888 22.8 268.34l7.408 29.711 5.822-1.452z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00F",
  fillRule: "evenodd",
  d: "m315.977 272.763-6.877 29.789-56.141-12.961 6.877-29.789z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#1A1919",
  strokeWidth: 2,
  d: "m305.093 320.748 11.682-49.139"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7F740",
  fillRule: "evenodd",
  d: "m312.651 285.237-1.35 5.846-55.721-12.864 1.35-5.846z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7F740",
  fillRule: "evenodd",
  d: "m290.709 266.888 5.822 1.452-7.408 29.711-5.822-1.452z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2F6B3F",
  fillRule: "evenodd",
  d: "m150.013 301.238 2.052 5.638 18.262-6.647-2.052-5.638z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#040B28",
  d: "M247.582 254.634H76.222c-2.872 0-5.222-2.356-5.222-5.236V82.602c0-2.88 2.35-5.236 5.221-5.236h166.14c2.872 0 5.221 2.356 5.221 5.236z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M130.661 113h5.371v32.883c0 6.368-5.319 11.483-11.89 11.483h-1.043c-6.623 0-11.89-5.167-11.89-11.587V113h5.319v32.883c0 3.601 2.92 6.577 6.78 6.577h.677c3.807 0 6.728-2.871 6.728-6.525V113zm39.947 21.452h-5.215c0-2.61-2.295-5.063-5.006-5.063h-1.2c-2.451 0-4.693 1.618-4.693 3.811 0 6.315 15.958 3.862 15.958 15.188 0 5.011-4.955 9.03-10.43 9.03h-1.356c-6.311 0-10.587-4.802-10.587-9.76v-.731h5.006v.574c0 2.923 2.608 5.428 5.789 5.428h1.148c2.868 0 5.319-1.983 5.319-4.645 0-6.629-16.115-4.489-16.115-14.719 0-5.167 4.537-8.717 9.961-8.717h1.2c6.831.052 10.221 5.585 10.221 9.604m31.29 12.736h5.163c0 4.802-4.693 10.178-11.264 10.178h-1.043c-6.623 0-11.891-5.167-11.891-11.587v-9.5c0-6.368 5.268-11.431 11.891-11.431h1.147c6.571 0 11.682 5.063 11.682 11.431v6.368h-19.609v3.445c0 3.758 3.077 6.837 7.041 6.837h.677c3.807.052 6.206-3.288 6.206-5.741m-14.028-11.066v1.984h14.654v-1.984c0-3.758-2.92-6.733-6.884-6.733h-.73c-3.963 0-7.04 2.975-7.04 6.733M111 192.545v-4.488h15.645v26.776h9.596v4.488H111v-4.488h10.639v-22.288zm10.013-14.249a2.783 2.783 0 0 1 2.764-2.766h.208a2.783 2.783 0 0 1 2.764 2.766 2.783 2.783 0 0 1-2.764 2.766h-.208c-1.512.053-2.764-1.2-2.764-2.766m27.118 31.578v-30.691h5.059v8.874h17.418v4.488H153.19v16.964c0 3.131 2.451 5.95 5.893 5.95h.626c3.129 0 5.684-2.819 5.684-5.95h5.163c0 5.95-3.911 10.491-11.056 10.491h-.626c-6.832 0-10.743-4.541-10.743-10.126m43.911 6.368c0-1.67 1.356-3.08 3.077-3.08a3.084 3.084 0 0 1 3.077 3.08 3.084 3.084 0 0 1-3.077 3.079 3.084 3.084 0 0 1-3.077-3.079"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "useit-midsummer-dark_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h319v321H0z"
})))));
export default SvgUseitMidsummerDark;